  function matchUsVsThemHeights() {
    const sections = document.querySelectorAll('.jj-us-vs-them');

    sections.forEach(function (section) {
      const headings = section.querySelectorAll('.jj-us-vs-them__heading');

      if (headings.length < 2) return;

      const titles = section.querySelectorAll('.jj-us-vs-them__heading h3');
      const descriptions = section.querySelectorAll('.jj-us-vs-them__heading p');
      const figures = section.querySelectorAll('.jj-us-vs-them__heading figure');

      // Reset heights before recalculating
      [titles, descriptions, figures].forEach(function (elements) {
        elements.forEach(function (element) {
          element.style.height = 'auto';
        });
      });

      function matchHeight(elements) {
        if (elements.length < 2) return;

        let maxHeight = 0;

        elements.forEach(function (element) {
          maxHeight = Math.max(maxHeight, element.offsetHeight);
        });

        elements.forEach(function (element) {
          element.style.height = maxHeight + 'px';
        });
      }

      // Match title heights
      matchHeight(titles);

      // Match description heights
      matchHeight(descriptions);

      // Match image/figure heights
      matchHeight(figures);
    });
  }
matchUsVsThemHeights();
document.addEventListener('DOMContentLoaded', matchUsVsThemHeights);
window.addEventListener('load', matchUsVsThemHeights);
window.addEventListener('resize', matchUsVsThemHeights);